import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    productBlock: 'flex flex-col gap-[40px]',
    productGrid:
      'relative container grid grid-cols-2 gap-x-[9px] gap-y-[9px] md:grid-cols-4 lg:gap-x-[20px] lg:gap-y-[40px]'
  }
});
